<template>

    <v-bottom-sheet v-model="componentVisible">

        <activity-filter
                v-bind="properties"
                :default-tab="defaultTab"
                @change="activityFilterChanged"
                @error="activityFilterError"
        ></activity-filter>

    </v-bottom-sheet>

</template>

<script>
    import ActivityFilter from '../../../components/UI/ActivityFilter';

    export default {

        components: {ActivityFilter},

        props: {
            open: {
                type: Boolean,
                required: false,
                default: false,
            },

            filter: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                componentVisible: false,
                properties: {},
                lastError: null,
                defaultTab: 0,
            }
        },

        watch: {
            open: function (bool) {
                this.componentVisible = bool;
                this.defaultTab = 0;
                this.defaultTab = this.lastError ? this.lastError.tabNumber : 0;
            },
            componentVisible: function (visible) {
                if (!visible) this.$emit('close');
            }
        },

        methods: {
            activityFilterChanged(filter) {
                this.properties=filter;
                this.lastError = null;
                this.$emit('change',filter);
            },
            activityFilterError(error) {
                this.lastError = error;
                this.$emit('error',error);
            }
        },

        created() {
            if (!this.$store.state.Segments) {
                this.$store.registerModule('Segments', Store);
            }

            this.properties = Object.assign({},this.filter);
        },
    };

</script>
